@if (enabled && activeInsurerModal) {
  @if (activeInsurerModal === SendLeadModalEnum.GROUPE_MUTUEL) {
    <app-send-groupe-mutuel-lead-modal
      #insurerModal
      [lead]="lead"
      [isStandalone]="false"
      [metadata]="lead?.metadata"
      (sent)="refreshTaskDetails()"
    />
  }
  <!-- To support a new insurer: add its SendLeadModalEnum value, a case in getSendLeadModal(),
        and an @if block here with the component and the same template variable. -->

  <button
    class="transparent-btn"
    (click)="openInsurerModal()"
    ngbTooltip="Envoyer la demande à l'assureur"
    i18n-ngbTooltip
  >
    <app-arrow-right-icon height="16px" width="16px" color="var(--brand-500)" />
  </button>
}
